const BriaEnvironment = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M17.0324 13.0555C18.4789 13.5191 19.4062 14.6319 19.4062 16.2639C19.4062 18.5079 17.6258 19.806 14.2135 19.806H7.5V6.82422H13.8425C17.088 6.82422 18.7571 8.17804 18.7571 10.1995C18.7571 11.4977 18.0895 12.4991 17.0324 13.0555ZM13.4716 9.08677H10.4858V12.1468H13.4716C14.9367 12.1468 15.7342 11.6275 15.7342 10.6075C15.7342 9.58749 14.9367 9.08677 13.4716 9.08677ZM13.9909 17.5435C15.5487 17.5435 16.3833 17.0613 16.3833 15.9486C16.3833 14.8544 15.5487 14.3351 13.9909 14.3351H10.4858V17.5435H13.9909Z"
			fill="#1A0638"
		/>
		<circle
			cx="13"
			cy="13.1875"
			r="12"
			stroke="#1A0638"
			strokeWidth="1.28571"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default BriaEnvironment;
